<app-header-landing></app-header-landing>
<div id="main">
    <div class="section" id="section">
        <div class="pre-landing">
            <div class="title-container">
                <h1>{{'pre_landing.title'|translate}}</h1>
            </div>
            <div class="sub-title-container">
                <h4>{{'pre_landing.sub_title'|translate}}</h4>
            </div>
            <div class="image-container">
                <img src="../../../assets/img/calendar.svg" alt="calendar" />
            </div>
            <div class="btn-container">
                <button class="my-button" (click)="goTo('home')">{{'pre_landing.starting'|translate}}</button>
            </div>
        </div>
    </div>
</div>